import { FilterSubmitButton, useFilterFormError } from '@/components/common/Filter'
import { InputSelect, InputText } from '@/components/common/Input'
import {
  FILTER_ADVANCED_COUNT_NUMBER_MAX,
  FILTER_ADVANCED_COUNT_NUMBER_MIN,
  FILTER_ADVANCED_COUNT_VALUE_OPERATOR_LABELS,
  FILTER_ADVANCED_COUNT_VALUE_OPERATORS,
  type FilterAdvancedCountPartialType,
  isFilterAdvancedCountNumberType,
} from '@/defs/filters'

import styles from './FiltersPanelAdvancedFormCount.module.scss'

type Props = {
  filter: FilterAdvancedCountPartialType
  onUpdate: (filter: FilterAdvancedCountPartialType) => void
}

const options = FILTER_ADVANCED_COUNT_VALUE_OPERATORS.map((operator) => ({
  label: FILTER_ADVANCED_COUNT_VALUE_OPERATOR_LABELS[operator].labelLong,
  value: operator,
}))

export const FiltersPanelAdvancedFormCount = ({ filter, onUpdate }: Props) => {
  const { number, operator } = filter
  const operatorError = useFilterFormError(!operator)
  const numberError = useFilterFormError(!isFilterAdvancedCountNumberType(number))

  const onUpdateOperator = (operator: FilterAdvancedCountPartialType['operator']) => {
    onUpdate({ ...filter, operator })
  }

  const onUpdateNumber = (numberInput: string) => {
    const number = parseInt(numberInput)
    onUpdate({ ...filter, number: !isNaN(number) ? number : undefined })
  }

  return (
    <div className={styles.container}>
      <div className={styles.inputOperator}>
        <InputSelect
          borderColor={operatorError.warn ? 'warning' : undefined}
          colorScheme='muted'
          onSelect={onUpdateOperator}
          options={options}
          placeholder='Choose a mode'
          value={operator}
          wiggle={operatorError.wiggle}
        />
      </div>
      <div className={styles.inputNumber}>
        <InputText
          autoFocus
          borderColor={numberError.warn ? 'warning' : undefined}
          colorScheme='muted'
          max={FILTER_ADVANCED_COUNT_NUMBER_MAX}
          min={FILTER_ADVANCED_COUNT_NUMBER_MIN}
          onChange={onUpdateNumber}
          placeholder='#'
          required
          type='number'
          value={number}
          wiggle={numberError.wiggle}
        />
      </div>
      <FilterSubmitButton />
    </div>
  )
}
